// extracted by mini-css-extract-plugin
export default {"box":"SetConstant_box__fWPft","selectTitle":"SetConstant_selectTitle__1uS-5","title":"SetConstant_title__iVV3D","inputTitle":"SetConstant_inputTitle__8uFel"};